/**
 * Cards e rodapé da listagem de NF-e de saída. As quantidades e os valores por status são do conjunto
 * filtrado sem o card selecionado (denegadas é só a quantidade, sem card); valorTotal é do conjunto exibido (com o card).
 */
export class NotaFiscalSaidaResumoStruct {
  totalNotas: number;
  pendentes: number;
  emTransmissao: number;
  rejeitadas: number;
  autorizadas: number;
  canceladas: number;
  denegadas: number;
  valorTotal: number;
  valorPendentes: number;
  valorEmTransmissao: number;
  valorRejeitadas: number;
  valorCanceladas: number;
  valorAutorizadas: number;
}
